import React from 'react';
import './App.css';
import Todos from "./components/todo"









const App=()=> {
  return (
    <div className="App">
    <Todos/>
    </div>
  );
}

export default App;
